class ViewpaybilllandingController {
  constructor($state, $scope, $window,storage,billingService, $rootScope, navigationManager, analyticsService) {
    this.name = 'viewpaybilllanding';
    this.state = $state;
    this.$rootScope = $rootScope;
    this.analyticsService = analyticsService;
    //this.$scope = $scope;
    this.$rootScope.accountPastdue = false;
    this.$rootScope.isPPVInhibit = false
    this.$rootScope.preDeauth = false;
    //customer cable-vision and suddenlink
    this.isCablevision = false;
    this.isSuddenlink = false;

    //bp-global parameters
    this.bpGlobalInfo = null;
    this.amountTestDue = 0;
    this.amountDueDate = '';
    this.creditBalance = false;
    this.creditAmount = 0;
    this.noPaymentDuewithAccBalance=false;
    this.noPaymentDue = false;
    this.hasOptimumId=false;
    this.currentAccount = null;
    this.items = [];
    this.deAuthInfo = null;
    this.errorPay = false;
    this.isPreDAuthTwo = false;
    this.isPreDAuthOne = false;
    this.paymentAlertMsg= '';
    this.isPastDue=false;
    this.paymentDue = false;
    this.landingPageViewBillLoader = true;
    this.bpGlobalFailed = false;

    this.isPPVProd = false;
    this.PPVInhibitBalance = 0;
    this.PPVInhibit = false
    this.PPVAmountdue = 0;

    //based on plant id will determine customer.
    console.log("my previous state is:",this.$rootScope.previousState);

    navigationManager.registerViewComponent(this, $scope, 'home.landingpage.viewpaybilllanding');

    //getting bp global data for
    billingService.getBpGlobalData().then((res)=>{
      //console.log('this is bp global information from landing page.--> ', res);
      if(res && res.data && res.data.status && res.data.status.statusCode === "00000"){
        //console.log("view bpGlobalInfo on landing page: ", res.data);
        this.bpGlobalInfo = res.data;
        this.amountTestDue = res.data.amountDue;
        this.PPVInhibitBalance = res.data.billPayCache.ppvinhibitBalance;
        this.PPVAmountdue = this.bpGlobalInfo.currentBalance + this.PPVInhibitBalance;
        console.log("this.PPVAmountdue is " + this.PPVAmountdue);

        if(this.bpGlobalInfo.dueDate !== null) {
          var myDate = this.bpGlobalInfo.dueDate;
          const parts = myDate.split('/');
          myDate = parts[0] + '/' + parts[1];
          this.amountDueDate = myDate;
        }

        // checking amount due in different phases
        if(this.bpGlobalInfo.currentBalance < 0){
          this.creditBalance = true;
          this.creditAmount = (this.bpGlobalInfo.currentBalance * -1);
          ////this.landingPageLoader = false;
          this.landingPageViewBillLoader = false;
        }
        else if(this.bpGlobalInfo.amountDue <= 0) {
          this.negative_amountDue = true;
          if(this.bpGlobalInfo.currentBalance > 0) {
            this.noPaymentDuewithAccBalance = true;
            ////this.landingPageLoader = false;
          } else {
            this.noPaymentDue = true;
            ////this.landingPageLoader = false;
          }
          this.landingPageViewBillLoader = false;
        }
        else if(this.bpGlobalInfo.amountDue > 0){

          //verifying from where bp global coming
          if(storage.getItem('session','hasOptimumId')){
            this.hasOptimumId=true;
          }
          // first we will get list of cards by getCurracc
          billingService.getCurrectAcc().then((resp)=>{
            //console.log("resp of current account on landing page.:", resp);
            if(resp && resp.paymentMethods){
              //console.log("This is Currect Account ebillInformationOutputs from landing page.---> ", resp.paymentMethods);
              this.currentAccount = resp;
              this.items = resp.paymentMethods;
              //console.log("this.items in landing page:", this.items);
            }
            else {
              this.items = [];
              //console.log("this.items in landing page:", this.items);
            }
          }).then(()=>{
            //this block plays pre-de auth one or two
            if(this.bpGlobalInfo.billPayCache && this.bpGlobalInfo.billPayCache.deAuthBalanceDue!= null && this.bpGlobalInfo.billPayCache.deAuthBalanceDue != 0){
              this.deAuthInfo = billingService.deauthInfo(this.bpGlobalInfo.billPayCache);
              //here we know we have deauth so now determining one or two so set text for alert and other msg.
              this.errorPay = true;
              document.getElementById('msgAlertBoxId').style.marginBottom = '3.7vh';
              document.getElementById('msgAlertBoxId').style.marginTop = '2vh';
              /*document.getElementById('landingBg').style.marginTop = '0vh';*/
              if(this.deAuthInfo.isDeauthTwo){
                this.isPreDAuthTwo = true;
                this.PPVInhibit = false;
                this.paymentAlertMsg='Your account is past due. Make a payment now to avoid service interruptions.';
              }else if(this.deAuthInfo.isDeauthOne){
                this.PPVInhibit = false;
                this.isPreDAuthOne = true;
                this.paymentAlertMsg='Your account is past due. Please make a payment by '+this.deAuthInfo.startDate+' to avoid late fees or service interruptions.';
              }
              //this.landingPageLoader = false;
              this.landingPageViewBillLoader = false;
              this.$rootScope.preDeauth = true;
              this.focus('navigation_btn0');


              /*************************************************************************/
              /*   The below block is to set the flagson the basis of bpglobal call    */
              /*************************************************************************/
              setTimeout(function() {
                navigationManager.registerNavigate('paynow-btn', 'down');
                navigationManager.registerNavigate('paynow-btn', 'left', 'navigation_btn0');
                navigationManager.registerNavigate('paynow-btn', 'up');
                navigationManager.registerNavigate('paynow-btn', 'right');
              }, 1000);
            }
            ///this block plays pastdue stuff
            else if(this.bpGlobalInfo.pastDueAmount > 0){
              this.PPVInhibit = false;
              this.errorPay = true;
              this.paymentAlertMsg='Your account is past due. Please make a payment to avoid late fees or service interruptions.';
              document.getElementById('msgAlertBoxId').style.marginTop = '2vh';
              document.getElementById('msgAlertBoxId').style.marginBottom = '3.7vh';
              /*document.getElementById('landingBg').style.marginTop = '0vh';*/
              this.isPastDue=true;
              this.$rootScope.accountPastdue = true;
              console.log("this.$rootScope.accountPastdue", this.$rootScope.accountPastdue);
              //this.landingPageLoader = false;
              this.landingPageViewBillLoader = false;
              this.focus('paynow-btn');


              /*************************************************************************/
              /*   The below block is to set the flagson the basis of bpglobal call    */
              /*************************************************************************/

              setTimeout(function() {
                navigationManager.registerNavigate('paynow-btn', 'down');
                navigationManager.registerNavigate('paynow-btn', 'left', 'navigation_btn0');
                navigationManager.registerNavigate('paynow-btn', 'up');
                navigationManager.registerNavigate('paynow-btn', 'right');
              }, 1000);
            }
            //checks if there is a ppv inhibit
            else if(this.PPVInhibitBalance != null && this.PPVInhibitBalance > 0 && this.isPPVProd){
              this.PPVInhibit = true;
              this.$rootScope.isPPVInhibit = true;
              this.landingPageViewBillLoader = false;
              this.focus('paynow-btn');
              setTimeout(function() {
                navigationManager.registerNavigate('paynow-btn', 'down');
                navigationManager.registerNavigate('paynow-btn', 'left', 'navigation_btn0');
                navigationManager.registerNavigate('paynow-btn', 'up');
                navigationManager.registerNavigate('paynow-btn', 'right');
              }, 1000);
            //if nothings remain and only amount due  
            } else {
              this.paymentDue = true;
              //this.landingPageLoader = false;
              this.landingPageViewBillLoader = false;
            }
          });
        }
      }
      else{
        this.bpGlobalFailed = true;
        this.landingPageViewBillLoader = false;
      }
    },()=>{
        this.bpGlobalFailed = true;
        this.landingPageViewBillLoader = false;
      //console.log('Something wrong with all call and bpglobal fail.');
    });

  }
  onPayNow() {
    console.log('!!omniture from landing pay Now');
    console.log('paperless : ' +this.$rootScope.omniturePaperlessbill +', billing status : ' +this.$rootScope.omnitureBillingStatus);
    this.analyticsService.sendReport('home', 'my account', 'event2', null, null, null, 'Pay Now', 
      this.$rootScope.analytics.omniturePath +'/viewpaybill', this.$rootScope.omnitureBillingStatus, this.$rootScope.omniturePaperlessbill, 
      this.$rootScope.analytics.omniturePath +'/landingpage/viewpaybilllanding');

    this.state.go('home.viewpaybill');
  }

  focus(id){
    console.log("id in focus:", id);
    setTimeout(function() {
      document.getElementById(id).focus();
    }, 300);
  }
}

ViewpaybilllandingController.$inject = ['$state', '$scope', '$window','storage','billingService', '$rootScope', 'navigationManager', 'analyticsService'];

export default ViewpaybilllandingController;



// WEBPACK FOOTER //
// ./client/app/components/landingpage/viewpaybilllanding/viewpaybilllanding.controller.js